import { NetworkType, NO_LIMIT } from '@tt4b/ttam-enums';
import { computed, Ref } from '@vue/composition-api';
import { NetWorkOptionsType } from './types';
import { i18n } from './../../../i18n';
import { createSharedComposable } from '@vueuse/core';

export const useNetworkOptions = createSharedComposable(function useNetworkOptions() {
  const networkOptions = computed(() => {
    const options: NetWorkOptionsType[] = Object.keys(NetworkType)
      .filter(item => !/^\d+$/.test(item))
      .map(item => ({
        name: item,
        value: NetworkType[item],
      }));
    options.unshift({
      name: i18n.t('adgroup_no_limit') as string,
      value: NO_LIMIT,
    });
    return options;
  });

  return {
    networkOptions,
  };
});

export function useNetworkName(opt: { network: Ref<(NetworkType | typeof NO_LIMIT)[]> }) {
  const { networkOptions } = useNetworkOptions();
  const { network } = opt;
  const netWorkMap = networkOptions.value.reduce((pre, cur) => {
    pre[cur.value] = cur.name;
    return pre;
  }, {});
  const networkName = computed(() => network.value.map(item => netWorkMap[item]));
  return {
    netWorkMap,
    networkName,
  };
}
